

const IndexCustodiansItemSchema = {
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default IndexCustodiansItemSchema
